import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { checkOutSchema } from '../schemas/check-out.schema';

/**
 * Validates if a specified action can be performed based on record data validation.
 * @param odometerValue - The odometer value to be validated. Must be a number and is required.
 * @param checkOutDate - The check-out date to be validated. Must be a date, required, and cannot be in the future.
 * @param abortEarly - Specifies whether validation should stop on the first error (default is false).
 * @returns An object containing the validation result:
 *   - isValid: A boolean indicating if the validation passed.
 *   - errors: An array of error messages if validation fails; otherwise, undefined.
 */
export const canPerformAction = (
	odometerValue: number,
	checkOutAt: Date,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	const validationResult: ValidationResult = checkOutSchema().validate(
		{ odometerValue, checkOutAt },
		{
			abortEarly,
		},
	);

	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	return { isValid: true };
};
